import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useRetryChatMessage = (chatId: string) => {
  const { call, isLoading: isRetrying } = useApiPrivateRequest<void>();
  const retryChatMessage = async (messageId: string) => {
    await call(`/chats/${chatId}/messages/${messageId}/retry`, "PUT");
  };

  return { retryChatMessage, isRetrying };
};
